<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title, code } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('icon')) {
        vnodes.push(<i class={[icon, 'iconfont']} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon} />)
      }
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.iconfont {
  color: #4F6389;
  font-size: 16px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue